import { useLocalStorage } from 'react-use';

const useShowLiveCodingWarningModal = ({ courseCode }) => {
  const [showLiveCodingWarning, setShowLiveCodingWarning] = useLocalStorage(
    'skooldio_show_live_coding_warning',
    {}
  );

  const shouldShowLiveCodingWarningModal = showLiveCodingWarning[courseCode] ?? true;

  const markLiveCodingWarningShown = () => {
    setShowLiveCodingWarning({ ...showLiveCodingWarning, [courseCode]: false });
  };

  return [shouldShowLiveCodingWarningModal, markLiveCodingWarningShown];
};

export default useShowLiveCodingWarningModal;
